module.exports = __webpack_public_path__ + "img/tab-cover-desktop.b1d12e7c.svg";